import { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetches all projects grouped by status from the backend.
 * Returns { completed, ongoing, all, loading, error }.
 */
export const useProjects = () => {
  const [completed, setCompleted] = useState([]);
  const [ongoing, setOngoing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchProjects = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/projects`, { timeout: 15000 });
        if (cancelled) return;
        setCompleted(res.data?.completed || []);
        setOngoing(res.data?.ongoing || []);
        setError(null);
      } catch (err) {
        if (cancelled) return;
        setError(err.message || 'Failed to load projects');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchProjects();
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    completed,
    ongoing,
    all: [...completed, ...ongoing],
    loading,
    error,
  };
};
